import { useQuery } from '@tanstack/react-query';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { type AnalyticsSearchStatsParams, getAnalyticsSearchStats } from '~/services/AnalyticsService';

import { analyticsQueryKeys } from './analyticsQueryKeys';

export function useGetAnalyticsSearchStats(params: AnalyticsSearchStatsParams | null) {
  const brand = useCurrentBrand();

  const query = useQuery({
    queryKey: params ? analyticsQueryKeys.stats({ ...params, brand }) : analyticsQueryKeys.statsIdle(),
    queryFn: async ({ signal }) => getAnalyticsSearchStats({ ...params, brand }, { signal }),
    enabled: params !== null,
    retry: false,
  });

  return { data: query.data, isFetching: query.isFetching, error: query.error, refetch: query.refetch };
}
